import { useRef, useState } from "react"

export function useOptimisticValue<T>(
  initialValue: T,
  commit: (value: T) => Promise<unknown>,
  onError?: (error: unknown) => void
) {
  const [value, setValue] = useState(initialValue)
  const prevRef = useRef<T>(initialValue)

  const update = async (next: T): Promise<void> => {
    const lastCommitted = prevRef.current
    setValue(next)

    try {
      await commit(next)
      prevRef.current = next // only update ref on successful commit
    } catch (error) {
      setValue(lastCommitted)
      onError?.(error)
    }
  }

  const reset = (next: T) => {
    prevRef.current = next
    setValue(next)
  }

  return { value, update, reset }
}
